import React, { useState } from "react";
import "./Blog.css";

const ShareButtons = ({ blogUrl, blogTitle }) => {
  const [copied, setCopied] = useState(false);
  const encodedUrl = encodeURIComponent(blogUrl);
  const encodedTitle = encodeURIComponent(blogTitle);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(blogUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="share-blog-hbt-container">
      <span className="share-blog-hbt-label">
        <i className="fa-solid fa-bullhorn" /> Share this blog
      </span>

      <a
        href={`https://api.whatsapp.com/send?text=${encodedTitle} - ${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className="share-blog-hbt-btn share-blog-hbt-whatsapp"
        title="Share on WhatsApp"
      >
        <i className="fa-brands fa-whatsapp" />
      </a>

      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className="share-blog-hbt-btn share-blog-hbt-facebook"
        title="Share on Facebook"
      >
        <i className="fa-brands fa-facebook-f" />
      </a>

      <a
        href={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className="share-blog-hbt-btn share-blog-hbt-twitter"
        title="Share on Twitter"
      >
        <i className="fa-brands fa-x-twitter" />
      </a>

      <button
        onClick={handleCopyLink}
        className="share-blog-hbt-btn share-blog-hbt-copy"
        title={copied ? "Link Copied!" : "Copy Link"}
      >
        <i className="fa-solid fa-link" />
      </button>
    </div>
  );
};

export default ShareButtons;
